// src/domains/types.ts —— 后台域契约（TD-806）
import type { Dict, Domain, DomainCtx } from '../../../shared/src/dc';
import type { AdminGp } from '../gp';
import type { AdminState, Page } from '../state';

export type AdminCtx = DomainCtx<AdminState, AdminGp>;

export interface AdminDomain extends Domain<AdminState, AdminGp> {
  readonly keys: readonly string[];
  // 该页下仍由影子实例提供的键（parity 比较集合，TD-825）：透传域返回 keys，原生域返回 []
  legacyKeysFor(page: Page): readonly string[];
}

export interface InputEvent {
  target: { value: string };
}

export function str(t: Dict, k: string): string {
  const v = t[k];
  return typeof v === 'string' ? v : '';
}

export function strArr(t: Dict, k: string): readonly string[] {
  const v = t[k];
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}
